import { AppliedItem, MainTitle, RaffleContent } from "../../../styles/theme";
import { CheckOutConfirm } from "../../../system/types/Reservation";
import { X } from "@phosphor-icons/react";
import PhotoGallery from "../../Common/Photo/PhotoGallery";

interface CheckOutModalProps {
  handleClose: () => void;
  data: CheckOutConfirm;
}

function CheckOutModalReport({ handleClose, data }: CheckOutModalProps) {
  return (
    <>
      <RaffleContent>
        <MainTitle>사용 후 보고</MainTitle>
        <AppliedItem onClick={handleClose}>
          <X size={32} />
        </AppliedItem>
      </RaffleContent>
      <PhotoGallery title="사용 후 보고 사진" photos={data?.attachmentFiles ?? []} />
    </>
  );
}

export default CheckOutModalReport;
